export enum DrawMode {
    Tick,
    Gesture,
}
